import React, { useState, useEffect, useRef, useContext } from 'react'
import * as FileSaver from 'file-saver'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Fade from '@material-ui/core/Fade'
import _get from 'lodash/get'

import { IProjectAsset } from '@/shared/models/project-asset'
import { ProjectItemWidgetContext } from '..'
import PagAlertDialog from '@/components/pag-alert'
import { useMutation } from '@apollo/react-hooks'
import { DELETE_PROJECT_ASSET } from '@/shared/graphql/mutations/mutationProjectAsset'
import { callPagApi } from '@/shared/services/pag-api'
import { useAuth0 } from '@/auth/index'
import { Context } from '@/shared/store/reducers/global-reducer'
import PagCircularIndeterminate from '@/components/pag-loading'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  assetItem: {
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  iconButtonWrapper: {
    maxWidth: 23,
    minWidth: 23,
    width: 23,
  },
  iconButton: {
    width: 12,
    padding: 0,
  },
}))

const ProjectItemAssetsComponent = (props: any) => {
  const { name, InputProps, handleCancel, handleChange, handleEdit } = props
  const currentAsset = useRef(null as any)
  const classes = useStyles()
  const { store } = useContext(Context)
  const { projectAssetTypes } = useContext(ProjectItemWidgetContext)
  const { getTokenSilently } = useAuth0()
  const { activeTenant } = store

  const [assets, setAssets] = useState([] as any)
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const [deleteProjectAsset, deleteProjectAssetRes] = useMutation(
    DELETE_PROJECT_ASSET,
    {
      onError: (err) => {
        // errorHandler(err)
      },
      onCompleted: (res) => {
        const success = _get(res, ['deleteProjectAsset', 'success'])
        const data = _get(res, ['deleteProjectAsset', 'data'])
        if (success) {
          handleChange(assets.filter((item: any) => item.id !== data), false);
        } else {
          // errorHandler('The overages were not deleted successfully. Please try again later.')
        }
      },
    }
  )

  useEffect(() => {
    const value = InputProps.value || []
    setAssets(value)

    return () => {}
  }, [InputProps.value])

  const handleOpenMenu = (event: any) => {
    setAnchorEl(event.currentTarget)
  }
  
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  
  const handleRemoveProjectAsset= (index: number) => {
    handleCloseMenu()
    setOpenDeleteConfirm(true)
  }

  const handleDeleteAsset = () => {
    let abortController: any
    if (currentAsset.current) {
      try {
        abortController = new AbortController()
        callPagApi('', getTokenSilently, deleteProjectAsset, {
                  tenantId: activeTenant?.id,
                  id: currentAsset.current.data.id,
                }, abortController.signal)
  
      } catch (err) {
        console.error('Error in Update Project', err)
        if (abortController) abortController.abort()  
      }
    }
  }
  
  return (
    <Grid container spacing={2}>

      {deleteProjectAssetRes.loading && <PagCircularIndeterminate />}

      {Boolean(assets.length) ? (
        <>
          {assets.map((asset: IProjectAsset, i: number) => (
            <Grid
              key={`project-asset-${i}`}
              item
              xs={12}
              className={classes.assetItem}
              onMouseEnter={() => {
                currentAsset.current = { data: asset, index: i }
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={3} className={'pag-text-ellipsis'}>
                  Count
                </Grid>
                <Grid item xs={2} className={'pag-text-ellipsis'}>
                  {asset.assetCount}
                </Grid>

                <Grid item xs={2} className={'pag-text-ellipsis'}>
                  Type
                </Grid>
                <Grid item xs={4} className={'pag-text-ellipsis'}>
                  {projectAssetTypes.find(type => type.id === asset.projectAssetTypeId)?.name}
                </Grid>

                <Grid item xs={1}>
                  <IconButton
                    color="inherit"
                    disableFocusRipple
                    size="small"
                    className={classes.iconButton}
                    onClick={handleOpenMenu}
                  >
                    <MoreVertIcon style={{ fontSize: 14 }} />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          ))}
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleCloseMenu}
            TransitionComponent={Fade}
          >
            <MenuItem
              onClick={() => {
                handleCloseMenu()
                handleEdit(currentAsset.current.data)
              }}
            >
              Edit
            </MenuItem>
            <MenuItem
              onClick={(e: any) => {
                if (currentAsset.current && currentAsset.current.index >= 0)
                  handleRemoveProjectAsset(currentAsset.current.id)
              }}
            >
              Delete
            </MenuItem>
          </Menu>

          {openDeleteConfirm && (
            <PagAlertDialog
              title="Delete Project Cost Item"
              content="Are you sure to delete the Project Cost Item?"
              open={true}
              handleClose={(e: boolean) => {
                setOpenDeleteConfirm(false)
                if (e) {
                  handleDeleteAsset()
                }
              }}
            />
          )}

        </>
      ) :  (
        <Grid item xs={12}>
          <Typography color="inherit" variant="subtitle1" align="center">
            <b>You haven't added</b>
            <br />
            <b>any assets yet.</b>
          </Typography>
          <Typography color="inherit" variant="subtitle2" align="center">
            Click the + sign to add your your first asset.
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

ProjectItemAssetsComponent.defaultProps = {
  handleChange: (e: any) => {},
  handleCancel: (e: any) => {},
}

export default ProjectItemAssetsComponent